
import { useTranslation } from 'react-i18next';

const Stats = () => {
  const { t } = useTranslation('common');

  const stats = [
    {
      value: t('stats.volumeValue'),
      unit: t('stats.volumeUnit'),
      label: t('stats.volume'),
      icon: 'ri-funds-line'
    },
    {
      value: t('stats.successValue'),
      unit: '',
      label: t('stats.success'),
      icon: 'ri-shield-check-line'
    },
    {
      value: t('stats.networksValue'),
      unit: t('stats.networksUnit'),
      label: t('stats.networks'),
      icon: 'ri-links-line'
    },
    {
      value: t('stats.merchantsValue'),
      unit: t('stats.merchantsUnit'),
      label: t('stats.merchants'),
      icon: 'ri-building-line'
    }
  ];

  return (
    <section id="stats" className="py-20 bg-slate-900 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(6,182,212,0.1),transparent_50%)]"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {t('stats.title', '平台数据概览')}
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            {t('stats.subtitle', '为全球企业提供可靠的数字货币支付基础设施')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="bg-slate-800/50 backdrop-blur-sm rounded-xl p-6 text-center border border-slate-700 hover:border-cyan-400 transition-all duration-300 group"
            >
              <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-cyan-400 to-blue-500 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                <i className={`${stat.icon} text-2xl text-white`}></i>
              </div>
              
              <div className="mb-2">
                <span className="text-4xl font-bold text-white">{stat.value}</span>
                {stat.unit && (
                  <span className="text-lg text-cyan-400 ml-1">{stat.unit}</span>
                )}
              </div>
              
              <p className="text-gray-300 font-medium">{stat.label}</p>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="mt-16 text-center">
          <p className="text-gray-400 text-lg">
            {t('stats.description', '数据实时更新，反映平台真实业务表现')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Stats;
